import { Text } from '@sbab-ui/components'

export interface TextProps {
  text: string
  type: 'h2' | 'lead'
}

export interface TextPropsWithId extends TextProps {
  id: number
}

const defaultTopTextConfig: TextPropsWithId[] = [
  {
    type: 'h2',
    text: 'Se vad ett månadssparande kan ge dig',
    id: 1,
  },
  {
    type: 'lead',
    text: 'Testa dig fram genom att fylla i startbelopp, hur mycket du vill spara i månaden och hur länge.',
    id: 2,
  },
]

function getTopTextConfig() {
  // The window.scaConfig?.topTextConfig is feature toggleable
  const topTextConfig = window.scaConfig?.topTextConfig
  if (topTextConfig) {
    return topTextConfig.map((item, index) => {
      return { ...item, id: index }
    })
  } else return defaultTopTextConfig
}

function TextComponent({ text, type }: TextProps) {
  return (
    <Text size={type} as={type === 'h2' ? 'h2' : 'p'} className="!mb-4 text-black">
      {text}
    </Text>
  )
}

interface Props {
  topTextConfig?: TextPropsWithId[]
}

export default function TopSection({ topTextConfig }: Readonly<Props>) {
  topTextConfig = topTextConfig ?? getTopTextConfig()
  return (
    <div className="mb-5">
      {topTextConfig.map((textConfig) => (
        <TextComponent text={textConfig.text} type={textConfig.type} key={textConfig.id} />
      ))}
    </div>
  )
}
